import React, { useEffect, useRef, useState } from "react";
import { useNavigate, NavLink, Link } from "react-router";
import ScratchImage from "./assets/img/scratch.jpg";
import ScratchCard from "react-scratchcard-v2";

import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import "./styles.css"; // Custom styles for the app
import { AirbudsYearlyHeader } from "./component/storyHeader";
import { useData } from "./data/dataContext";

export const Artist = () => {
  const projectVisor = useRef();
  const { data } = useData();
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [showInstruction, setShowInstruction] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setWidth(projectVisor.current.offsetWidth);
    setHeight(projectVisor.current.clientHeight);
  }, []);

  const handleScratchComplete = () => {
    setShowInstruction(false);

    setTimeout(() => {
      navigate("/artist-top");
    }, 2000);
  };

  if (!data) {
    return <EmptyScreen text="loading..." />;
  }

  if (!data.top_artists || data.top_artists.length <= 0) {
    return (
      <div ref={projectVisor} className="content app-artist">
        <p>No artist</p>
      </div>
    );
  }

  const topArtistUrl = data.top_artists[0].artist_id.artwork;
  const topArtistName = data.top_artists[0].artist_id.name;
  const topArtistRank = data.top_artists[0].rank;
  const trackPlayed = data.top_artists[0].play_count;

  return (
    <div className="app-artist">
      <div className="scratch-container" ref={projectVisor}>
        <ScratchCard
          className="scratch-card"
          width={width}
          height={height}
          image={ScratchImage}
          finishPercent={50}
          brushSize={50}
          onComplete={handleScratchComplete}
        >
          <img
            referrerPolicy="no-referrer"
            src={topArtistUrl}
            alt="airbuds yearly recap"
            className="scratch-img"
          />
        </ScratchCard>
      </div>

      <div className="content content-artist no-touch">
        <AirbudsYearlyHeader
          closeAction={() => {
            navigate("/menu");
          }}
        />
        {showInstruction && <ArtistScratch />}
        {!showInstruction && (
          <div className="scratch-artist">
            <h2 className="light-headline scratch-title"></h2>
            <p className="headline scratch-name">{topArtistName}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export const ArtistScratch = () => {
  return (
    <div className="scratch-artist">
      <h2 className="light-headline scratch-title"></h2>

      <h2 className="light-headline scratch-title">
        Your top artist
        <br />
        of the year
      </h2>

      <p className="headline scratch-instruction">
        scratch to
        <br />
        to discover
      </p>

      <DotLottieReact
        className="scratch-animation"
        src="https://lottie.host/d10ff161-b4b0-4572-aec8-0c2a4a0dfd5c/HuBBXK4wL8.lottie"
        loop
        autoplay
      />
    </div>
  );
};
